<template>
  <v-dialog persistent :value="show" max-width="1000">
    <v-card>
      <button style="width: 1px; height: 1px; display: none"></button>
      <div class="text-xs-right">
        <v-btn name="close" small flat fab @click="onClose">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <div class="list-categories pb-3">
          <div>
            <div
              class="category"
              v-for="(category, index) in categorylist"
              :key="'category_' + index"
            >
              <conversation-grouping-edit
                :categorylist="categorylist"
                v-model="categorylist[index]"
                :prefix="prefix"
                @onDelete="onDeleteCategory(index, $event)"
              >
                <template slot="move">
                  <move-vertical
                    :index="index"
                    :max="categorylist.length"
                    @onMove="onMove(index, $event)"
                    style="
                      width: 20px;
                      min-width: 20px;
                      display: inline-block;
                      float: left;
                      margin-right: 10px;
                    "
                  >
                    <div></div>
                  </move-vertical>
                </template>
              </conversation-grouping-edit>
            </div>
            <div>
              <div
                class="btn-add text-xs-center"
                style="padding: 20px 0"
                v-if="!isAdd"
                @click="onAddNew"
              >
                <em class="fa fa-plus" />
                {{ $t('Add new categories') }}
              </div>
              <div class="category" v-else>
                <div style="margin-bottom: 0">
                  <div v-if="isLoading" style="padding-top: 15px; padding-bottom: 15px">
                    <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
                  </div>
                  <template v-else>
                    <div
                      class="category-name form-control"
                      :class="{ 'has-error': errors.has('categoryname') }"
                      style="width: 100%"
                    >
                      <input
                        v-validate="`excluded: ${categoryname}`"
                        ref="newCategory"
                        type="text"
                        name="categoryname"
                        :data-vv-as="$t('Category name')"
                        v-model="newCategory.name"
                        :placeholder="$t('Enter Category Name')"
                      />
                      <span class="text-error" v-if="errors.has('categoryname')">{{
                        errors.first('categoryname')
                      }}</span>
                      <div class="text-xs-center">
                        <v-btn outline color="grey" @click="onCancelAddCategory">{{
                          $t('cancel')
                        }}</v-btn>
                        <v-btn depressed color="primary" @click="onAddCategory">{{
                          $t('Save')
                        }}</v-btn>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import MoveVertical from '@/components/elements/MoveVertical'
import ConversationGroupingEdit from './ConversationGroupingEdit'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import api from '@/api'
import draggable from 'vuedraggable'

export default {
  props: ['value', 'show', 'prefix'],
  computed: {
    categoryname() {
      return this.categorylist.map((v) => v.name)
    },
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    }
  },
  data: function () {
    return {
      categorylist: this.value,
      currentCategory: null,
      currentSubCategory: null,
      newCategory: {
        name: null
      },
      isLoading: false,
      newSubCategory: {
        name: null
      },
      showEdit: false,
      isAdd: false
    }
  },
  mounted: function () {},
  components: {
    'conversation-grouping-edit': ConversationGroupingEdit,
    draggable,
    PulseLoader,
    MoveVertical
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onMove(index, direction) {
      const vm = this
      if (direction == 'up') {
        vm.categorylist.splice(index, 0, vm.categorylist.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        vm.categorylist.splice(index, 0, vm.categorylist.splice(index + 1, 1)[0])
      }
      this.checkMove()
    },
    onAddNew: function () {
      const vm = this
      vm.isAdd = true
      vm.$nextTick(function () {
        vm.$refs.newCategory.focus()
      })
    },
    close: function () {
      const vm = this
      vm.showEdit = false
      vm.nextTick(function () {})
    },
    checkMove: function (e) {
      const vm = this
      let input = []
      input = vm.categorylist.map((el, index) => {
        return { id: el.id, priority: index }
      })

      api.putPriorityGroupConversation(
        { groupsConversation: input, pageid: this.pageid },
        function (error, response) {
          if (error) {
            console.error(error)
            vm.isLoading = false
            return
          }
        }
      )
      vm.$emit('input', vm.categorylist)
    },
    onEditCategory: function (index) {
      this.currentCategory = this.categorylist[index]
      this.showEdit = true
    },
    onSelectCategory: function (index) {
      this.currentCategory = this.categorylist[index]
    },
    onCancelAddCategory: function () {
      const vm = this
      vm.newCategory.name = ''
      vm.isAdd = false
    },
    onAddCategory: function () {
      const vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }
        if (vm.newCategory.name == null || vm.newCategory.name.trim() == '') {
          vm.newCategory.name = ''
          vm.isAdd = false
          return false
        }
        vm.newCategory.name = (vm.prefix ? vm.prefix + '/' : '') + vm.newCategory.name
        let data = {
          pageid: vm.pageid,
          name: vm.newCategory.name
        }
        vm.isLoading = true
        api.postGroupConversation(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.isLoading = false
            return
          }
          vm.newCategory.status = true
          vm.categorylist.push(vm.newCategory)
          vm.newCategory = { name: null, status: null }
          vm.isAdd = false
          vm.isLoading = false
          vm.$emit('input', vm.categorylist)
          vm.$emit('onCategoryChange')
        })
      })
    },
    onDeleteCategory: function (index, payload) {
      const vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.categorylist[index].name.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          focusConfirm: true
        })
        .then((result) => {
          if (result.value) {
            api.deleteGroupConversation(payload, function (error, response) {
              if (error) {
                console.error(error)
                return
              }

              vm.categorylist.splice(index, 1)
              vm.$emit('input', vm.categorylist)
              vm.$emit('onCategoryChange')
              vm.$emit('deleteCategory', payload)
            })
          }
        })
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.categorylist = newVal
    }
  }
}
</script>

<style>
.list-category-group {
  text-decoration: none;
  list-style-type: none;
  padding-left: 0px;
}

.list-category:first-child {
  border-top: 1px solid #eee;
}

.list-category {
  padding: 10px;

  border-bottom: 1px solid #eee;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}

.list-category.active {
  background-color: #007bff;
  color: white;
}

.grab {
  cursor: -webkit-grab;
  cursor: grab;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/ConversationGrouping.vue